module.exports = __webpack_public_path__ + "static/Group 557-be1f3ed2e41d521282a98f112a39565c.png";